import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { transitionGrow } from '../theme/mixins';
import PopperUi from '../Popper';
import CornerBase from './Corner';
import PaperUi from '../Paper';
export var Popper = styled(PopperUi).withConfig({
  displayName: "ui-kit-Popper",
  componentId: "ui-kit-k71len"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: ", ";\n  pointer-events: none;\n\n  &.interactive {\n    pointer-events: auto;\n  }\n"], ["\n  z-index: ", ";\n  pointer-events: none;\n\n  &.interactive {\n    pointer-events: auto;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.zIndex.tooltip;
});
export var Root = styled.div.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-1c31s8f"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var Paper = styled(PaperUi).withConfig({
  displayName: "ui-kit-Paper",
  componentId: "ui-kit-6yo3tn"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  border-radius: 4px;\n  color: ", ";\n\n  ", "[data-popper-placement^='left'] & {\n    transform-origin: right center;\n    margin: 0 8px;\n  }\n  ", "[data-popper-placement^='right'] & {\n    transform-origin: left center;\n    margin: 0 8px;\n  }\n  ", "[data-popper-placement^='top'] & {\n    transform-origin: center bottom;\n    margin: 8px 0;\n  }\n  ", "[data-popper-placement^='bottom'] & {\n    transform-origin: center top;\n    margin: 8px 0;\n  }\n\n  ", "\n"], ["\n  position: relative;\n  border-radius: 4px;\n  color: ", ";\n\n  "
/* sc-sel */
, "[data-popper-placement^='left'] & {\n    transform-origin: right center;\n    margin: 0 8px;\n  }\n  "
/* sc-sel */
, "[data-popper-placement^='right'] & {\n    transform-origin: left center;\n    margin: 0 8px;\n  }\n  "
/* sc-sel */
, "[data-popper-placement^='top'] & {\n    transform-origin: center bottom;\n    margin: 8px 0;\n  }\n  "
/* sc-sel */
, "[data-popper-placement^='bottom'] & {\n    transform-origin: center top;\n    margin: 8px 0;\n  }\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
      background = _a.background;
  return theme.palette.background.neutral[background || 'popover'];
},
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root, transitionGrow({
  startSelector: '.grow-appear > &, .grow-enter > &',
  startActiveSelector: '.grow-appear-active > &, .grow-enter-active > &',
  exitSelector: '.grow-exit > &',
  exitActiveSelector: '.grow-exit-active > &'
}));
export var TooltipElement = styled.div.withConfig({
  displayName: "ui-kit-TooltipElement",
  componentId: "ui-kit-grqdz8"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  color: ", ";\n  font-family: ", ";\n  padding: 8px 8px;\n  box-sizing: border-box;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.2px;\n  max-width: 316px;\n\n  &.touch {\n    padding: 8px 16px;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: normal;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  color: ", ";\n  font-family: ", ";\n  padding: 8px 8px;\n  box-sizing: border-box;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.2px;\n  max-width: 316px;\n\n  &.touch {\n    padding: 8px 16px;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: normal;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
});
export var Corner = styled(CornerBase).withConfig({
  displayName: "ui-kit-Corner",
  componentId: "ui-kit-e5gpks"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  color: inherit;\n\n  ", "[data-popper-placement='top-start'] & {\n    left: 11px;\n    bottom: -5px;\n    transform: rotate(180deg);\n  }\n\n  ", "[data-popper-placement='top'] & {\n    left: 50%;\n    transform: rotate(180deg) translate(50%);\n    bottom: -5px;\n  }\n\n  ", "[data-popper-placement='top-end'] & {\n    right: 11px;\n    bottom: -5px;\n    transform: rotate(180deg);\n  }\n\n  ", "[data-popper-placement='bottom-start'] & {\n    left: 11px;\n    top: -5px;\n  }\n\n  ", "[data-popper-placement='bottom'] & {\n    left: 50%;\n    transform: translate(-50%);\n    top: -5px;\n  }\n\n  ", "[data-popper-placement='bottom-end'] & {\n    right: 11px;\n    top: -5px;\n  }\n\n  ", "[data-popper-placement='left-start'] & {\n    transform: rotate(90deg) translate(-25%, -50%);\n    right: -5px;\n    top: 50%;\n  }\n\n  ", "[data-popper-placement='left'] & {\n    transform: rotate(90deg) translate(-25%, -50%);\n    right: -5px;\n    top: 50%;\n  }\n\n  ", "[data-popper-placement='left-end'] & {\n    transform: rotate(90deg) translate(-25%, -50%);\n    right: -5px;\n    top: 50%;\n  }\n\n  ", "[data-popper-placement='right-start'] & {\n    transform: rotate(-90deg) translate(25%, -50%);\n    left: -5px;\n    top: 50%;\n  }\n\n  ", "[data-popper-placement='right'] & {\n    transform: rotate(-90deg) translate(25%, -50%);\n    left: -5px;\n    top: 50%;\n  }\n\n  ", "[data-popper-placement='right-end'] & {\n    transform: rotate(-90deg) translate(25%, -50%);\n    left: -5px;\n    top: 50%;\n  }\n"], ["\n  position: absolute;\n  color: inherit;\n\n  "
/* sc-sel */
, "[data-popper-placement='top-start'] & {\n    left: 11px;\n    bottom: -5px;\n    transform: rotate(180deg);\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='top'] & {\n    left: 50%;\n    transform: rotate(180deg) translate(50%);\n    bottom: -5px;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='top-end'] & {\n    right: 11px;\n    bottom: -5px;\n    transform: rotate(180deg);\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='bottom-start'] & {\n    left: 11px;\n    top: -5px;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='bottom'] & {\n    left: 50%;\n    transform: translate(-50%);\n    top: -5px;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='bottom-end'] & {\n    right: 11px;\n    top: -5px;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='left-start'] & {\n    transform: rotate(90deg) translate(-25%, -50%);\n    right: -5px;\n    top: 50%;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='left'] & {\n    transform: rotate(90deg) translate(-25%, -50%);\n    right: -5px;\n    top: 50%;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='left-end'] & {\n    transform: rotate(90deg) translate(-25%, -50%);\n    right: -5px;\n    top: 50%;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='right-start'] & {\n    transform: rotate(-90deg) translate(25%, -50%);\n    left: -5px;\n    top: 50%;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='right'] & {\n    transform: rotate(-90deg) translate(25%, -50%);\n    left: -5px;\n    top: 50%;\n  }\n\n  "
/* sc-sel */
, "[data-popper-placement='right-end'] & {\n    transform: rotate(-90deg) translate(25%, -50%);\n    left: -5px;\n    top: 50%;\n  }\n"])),
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root);
export var Line = styled.div.withConfig({
  displayName: "ui-kit-Line",
  componentId: "ui-kit-18fcbxi"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex: 0 0 2px;\n  border-radius: 2px;\n  margin-right: 7px;\n\n  &.positive {\n    background-color: ", ";\n  }\n\n  &.negative {\n    background-color: ", ";\n  }\n\n  &.note {\n    background-color: ", ";\n  }\n"], ["\n  flex: 0 0 2px;\n  border-radius: 2px;\n  margin-right: 7px;\n\n  &.positive {\n    background-color: ", ";\n  }\n\n  &.negative {\n    background-color: ", ";\n  }\n\n  &.note {\n    background-color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.positive.mid;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.negative.mid;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.note.mid;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;